import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './lib/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import LendingTerms from './pages/LendingTerms';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import ResponsibleUse from './pages/ResponsibleUse';
import AccountDeletion from './pages/AccountDeletion';
import LoanBackfill from './pages/LoanBackfill';

function App() {
  return (
    <Router>
      <LanguageProvider>
        <div className="app">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/lending-terms" element={<LendingTerms />} />
              <Route path="/responsible-use" element={<ResponsibleUse />} />
              <Route path="/delete-account" element={<AccountDeletion />} />
              <Route path="/loan-backfill" element={<LoanBackfill />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </LanguageProvider>
    </Router>
  );
}

export default App;
